import React, { ReactNode } from "react";
import LockIcon from "../icons/LockIcon";

import { Box } from "./chakra";
import { Badge, FormLabelProps, HStack } from "@chakra-ui/react";

const FormLabel = ({
  children,
  required = false,
  showNotRequired = false,
  htmlFor = "",
  unpublished = false,
  ...props
}: {
  children: ReactNode;
  required?: boolean;
  showNotRequired?: boolean;
  htmlFor?: string;
  unpublished?: boolean;
} & FormLabelProps) => {
  return (
    <Box
      as="label"
      alignItems="center"
      gap={1}
      fontSize={{ base: "sm", sm: "md" }}
      fontWeight="600"
      htmlFor={htmlFor}
      display="inline-block"
      {...props}
    >
      <HStack gap={0} wrap="wrap">
        <Box mr={required || showNotRequired || unpublished ? 1 : 0}>
          {children}
        </Box>
        {required && (
          <Box mr={2}>
            <Badge
              background="caution"
              color="#FFF"
              fontSize="0.625rem"
              mb={0.5}
              pt={"1px"}
            >
              必須
            </Badge>
          </Box>
        )}
        {!required && showNotRequired && (
          <Box mr={2}>
            <Badge
              background="#6A7573"
              color="#FFF"
              fontSize="0.625rem"
              mb={0.5}
              pt={"1px"}
            >
              任意
            </Badge>
          </Box>
        )}
        {unpublished && (
          <HStack color="textGray" gap={0} mb={0.5}>
            <LockIcon />
            <Box as="span" fontSize="xs" fontWeight="normal" mt={1}>
              この情報は公開されません
            </Box>
          </HStack>
        )}
      </HStack>
    </Box>
  );
};

export default FormLabel;
